import * as React from "react";
import { getValueFromInput } from "util/FormsUtils";
import { Input } from "components/bootstrap";
import { useIndexRetention } from "components/indices/contexts/IndexRetentionContext";
const ClosingRetentionStrategyConfiguration = ({
  updateConfig,
  disabled = false
}) => {
  const [maxNumberOfIndices, setMaxNumberOfIndices] = useIndexRetention().useMaxNumberOfIndices;
  const _onInputUpdate = (field) => (e) => {
    const update = {};
    const value = getValueFromInput(e.target);
    update[field] = value;
    setMaxNumberOfIndices(value);
    updateConfig(update);
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      disabled,
      type: "number",
      id: "max-number-of-indices",
      label: "Max number of indices",
      onChange: _onInputUpdate("max_number_of_indices"),
      value: maxNumberOfIndices,
      min: 1,
      help: /* @__PURE__ */ React.createElement("span", null, "Maximum number of indices to keep before ", /* @__PURE__ */ React.createElement("strong", null, "closing"), " the oldest ones"),
      required: true
    }
  ));
};
export default ClosingRetentionStrategyConfiguration;
